import {AuthService} from "./AuthService";

export class ShopifyProductService {
    url = `campaigns/`;

    listProducts(campaignId, query = '', cursor = null) {
        return AuthService.apiGet(this.url + campaignId + "/shopify_products/", {
            params: {query: query, cursor: cursor},
        }).then(res => res.data.data);
    }

    updateTracking(campaignId, activate, deactivate, mode) {
        return AuthService.apiPost(this.url + campaignId + "/shopify_tracking/", {
            activate: activate,
            deactivate: deactivate,
            mode: mode,
        }).then(res => res.data.data);
    }
}
